import { render, staticRenderFns } from "./WorksheetPost.vue?vue&type=template&id=1a72b948&scoped=true"
import script from "./WorksheetPost.vue?vue&type=script&lang=js"
export * from "./WorksheetPost.vue?vue&type=script&lang=js"
import style0 from "./WorksheetPost.vue?vue&type=style&index=0&id=1a72b948&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a72b948",
  null
  
)

export default component.exports